import { useEffect, useState } from 'react';
import { getCrmRecordChannelManager } from '../ChannelManager';
import { CrmRealtimeUpdateMessageType } from '../messageTypes';
const ALL_MESSAGE_TYPES = Object.values(CrmRealtimeUpdateMessageType);

/**
 * A hook that subscribes to a record channel and calls the onMessage function when a message is received.
 *
 * @param param0 - The parameters for the hook.
 * @param param0.objectTypeId - The object type ID.
 * @param param0.objectId - The object ID.
 * @param param0.onMessage - The function to call when a message is received.
 * @param param0.onSubscribeError - The function to call when an error occurs when attempting to subscribe to the channel.
 * @param param0.messageTypes - The message types to subscribe to.
 *
 * @returns The status of the subscription.
 */
const useCrmRecordRealtimeSubscription = ({
  objectTypeId,
  objectId,
  onMessage,
  onSubscribeError,
  messageTypes = ALL_MESSAGE_TYPES
}) => {
  const [status, setStatus] = useState('IDLE');
  useEffect(() => {
    let unsubscribe = null;
    setStatus('SUBSCRIBING');
    getCrmRecordChannelManager().subscribe(objectTypeId, objectId, messageTypes, onMessage).then(u => {
      unsubscribe = u;
      setStatus('SUBSCRIBED');
    }).catch(err => {
      setStatus('ERROR');
      onSubscribeError === null || onSubscribeError === void 0 || onSubscribeError(err instanceof Error ? err : new Error(String(err)));
    });
    return () => {
      var _unsubscribe;
      (_unsubscribe = unsubscribe) === null || _unsubscribe === void 0 || _unsubscribe();
    };
  }, [onMessage, objectId, objectTypeId, messageTypes, onSubscribeError]);
  return {
    status
  };
};
export default useCrmRecordRealtimeSubscription;